/**
 * Galley #21943: re-renders the routed page when the time-zone switch
 * changes, so every time on it is formatted again in the new zone. The
 * formatters (`lib/utils.ts`) are plain functions that read the choice at
 * call time; rendering again is what makes them run again.
 *
 * It re-renders, it does not remount (ticketyboo's #22203): the page's own
 * state stays where it was, so a chat conversation, a half-typed question
 * or unsaved form edits survive a flip. `children` is a function so that
 * every flip builds the page's elements afresh and React renders each
 * component again (an element passed down unchanged would be skipped).
 * A `useMemo` that formats a time lists the choice in its dependencies.
 * Query data is cached above this, so nothing is fetched again.
 */
import { Fragment, type ReactNode } from "react";

import { useTimeZonePref } from "@/lib/timezone";

export function TimeZoneRerender({ children }: { children: () => ReactNode }) {
  useTimeZonePref();
  return <Fragment>{children()}</Fragment>;
}
